import {Reducer} from 'redux';
import initialState from './state';
import {IReduxAction, IReduxNavigationState} from '../../@interfaces';
import {NAVIGATION_CLEAR_CONFIG, NAVIGATION_SET_CONFIG} from './constants';

const reducer: Reducer = (state: IReduxNavigationState = initialState, action: IReduxAction): IReduxNavigationState => {
	switch (action.type) {
		case NAVIGATION_SET_CONFIG:
			return {...state, ...action.payload, loaded: true};

		case NAVIGATION_CLEAR_CONFIG:
			return {...state, sidebar: [], loaded: false};

		default:
			break;
	}

	return state;
};

export default reducer;
